import Bowser from 'bowser'

export default function platformClasses() {
  const browser = Bowser.getParser(window.navigator.userAgent)
  const osName = browser.getOSName(true)
  const platformType = browser.getPlatformType(true)

  document.documentElement.classList.add(`system-${osName}`, `platform-${platformType}`)

  return { osName, platformType }
}